import { ROLE_LUX_PLUS_ADMIN } from '~/consts/roles';

import { UserType } from '~/types/responses';

export function hasLuxPlusAdminAccess(user: UserType | null) {
  return user?.roles.includes(ROLE_LUX_PLUS_ADMIN);
}
